import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mg-t-20 mg-b-20" }
const _hoisted_2 = { class: "mg-t-20 border-top" }
const _hoisted_3 = { class: "title-box flex flex-ai-c flex-jc-sb mg-b-20" }
const _hoisted_4 = { class: "button-list flex" }
const _hoisted_5 = { class: "hint flex flex-ai-c mg-r-20" }
const _hoisted_6 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cashInfo = _resolveComponent("cashInfo")!
  const _component_searchComponent = _resolveComponent("searchComponent")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Download = _resolveComponent("Download")!
  const _component_tableComponent = _resolveComponent("tableComponent")!
  const _component_dialogCheckDetail = _resolveComponent("dialogCheckDetail")!
  const _component_dialogUploadSalary = _resolveComponent("dialogUploadSalary")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_cashInfo, { date: _ctx.queryDate }, null, 8, ["date"])
    ]),
    _createVNode(_component_el_card, {
      shadow: "never",
      class: "container"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_searchComponent, {
          "search-list": _ctx.searchList,
          "onUpdate:searchList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchList) = $event)),
          "button-list": _ctx.buttonList,
          onDoSearch: _ctx.handleSearch
        }, null, 8, ["search-list", "button-list", "onDoSearch"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title fs-16" }, "核算列表", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: "",
                  "raw-content": "",
                  placement: "top"
                }, {
                  content: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("div", null, "平台无法预测到您的其他支出项与你上传数据的正确性，下列公式仅供参考。", -1),
                    _createElementVNode("div", { class: "mg-t-5" }, "本月薪资: ", -1),
                    _createElementVNode("div", { class: "mg-t-5" }, "实发金额 + 实际预支金额 = 本月应发金额", -1)
                  ])),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_WarningFilled)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "fc-lightgray mg-l-10" }, "智能核算", -1))
              ]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSalaryDialog = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Upload)
                    ]),
                    _: 1
                  }),
                  _cache[6] || (_cache[6] = _createTextVNode(" 导入工资表 "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "success",
                onClick: _ctx.exporttable
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Download)
                    ]),
                    _: 1
                  }),
                  _cache[7] || (_cache[7] = _createTextVNode(" 导出核算表 "))
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createVNode(_component_tableComponent, {
            class: "mg-t-10",
            "table-data": _ctx.tableData,
            "table-head": _ctx.tableHead,
            "row-key": "idCardNo",
            onSelectionChange: _ctx.handleSelectionChange,
            "page-info": _ctx.pageInfo,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange
          }, {
            operate: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  type: "text",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (_ctx.handleArchive(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("查看详情")
                  ])),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["table-data", "table-head", "onSelectionChange", "page-info", "onSizeChange", "onCurrentChange"])
        ]),
        _createVNode(_component_dialogCheckDetail, {
          show: _ctx.showDialog,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDialog) = $event)),
          query: _ctx.queryData,
          type: _ctx.type
        }, null, 8, ["show", "query", "type"]),
        _createVNode(_component_dialogUploadSalary, {
          show: _ctx.showSalaryDialog,
          "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showSalaryDialog) = $event)),
          onRefresh: _ctx.handleRefresh
        }, null, 8, ["show", "onRefresh"])
      ]),
      _: 1
    })
  ]))
}